class ChannelActions {
    static CHANNEL_REQUEST = "CHANNEL_REQUEST";
    static CHANNEL_SUCCESSFUL = "CHANNEL_SUCCESSFUL";
    static CHANNEL_FAILED = "CHANNEL_FAILED";

    static channelRequest() {
        return {
            type: this.CHANNEL_REQUEST
        };
    }
    static channelSuccessul(data) {
        // console.log(data,"channel action")
        return {
            type: this.CHANNEL_SUCCESSFUL,
            data
        };
    }
    static channelFailed(error) {
        return {
            type: this.CHANNEL_FAILED,
            error
        };
    }
}

export default ChannelActions;
